// extracted by mini-css-extract-plugin
export var actionText = "_kz-4";
export var container = "_kz-0";
export var leftSection = "_kz-1";
export var rightSection = "_kz-2";
export var settingsButton = "_kz-6";
export var settingsIcon = "_kz-7";
export var shortcut = "_kz-5";
export var shortcutGroup = "_kz-3";